module.exports = __webpack_public_path__ + "media/images/version_merge/hero_orange-c53a2eb27a0ec80b3fc65433feef417f.jpg";